<template>
  <div class="home-tab">
    <ul class="tabs">
      <li
        v-for="(item, index) in tabs"
        :key="index"
        class="tab"
        :class="{ 'is-active': curTab === index }"
      >
        <a
          class="test-a"
          href="javascript:"
          @click="changeTab(index)"
        >
          <span class="tabs-a">
            <span
              class="tabs-icon"
              :class="curTab === index ? item.icon : item.active_icon"
            />
            <span>{{ item.text }}</span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default () {
        return []
      },
    },
    curTab: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    changeTab (index) {
      this.$emit('changeTab', index)
    },
  },
}
</script>

<style lang="scss" scoped>
$tabs-height: 70px;
.home-tab {
  background: #3c3d4b;
}
.tabs {
  display: flex;
  height: $tabs-height;
  line-height: $tabs-height;
}
.tab {
  flex: 1;
  text-align: center;
  border-top: none;
  background: #f2f2f2;
  border-radius: 10px 10px 0px 0px;
  a {
    font-size: 28px;
    color: #666666;
    display: block;
    font-weight: 400;
    &:hover {
      .super-member-tips {
        display: block;
      }
    }
  }
  &:first-child {
    border-left: none;
  }
  &:last-child {
    border-right: none;
  }

  .tip {
    color: #b07400;
    font-size: 13px;
  }
  .tabs-a {
    position: relative;
    display: inline-block;
    line-height: $tabs-height;
    vertical-align: top;
    .tabs-icon {
      margin-right: 6px;
    }
  }
  &.is-active {
    border: none;
    background: #fff;
    a {
      color: #a63227;
    }
    .tip {
      color: #732d0a;
    }
  }
}
</style>
